import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'

import { SingleValueBonusDescription } from './components/SingleValueBonusDescription/SingleValueBonusDescription'
import { BonusParametersDescription } from './components/BonusParametersDescription/BonusParametersDescription'

import { sortReserveBattleTypes, getReserveParameterByKey } from 'helpers/reserves'

import styles from './ReserveBonus.scss'

const ReserveBonus = ({
    reserveInfo,
    level,
    nextLevel,
    isNextLevelHighlighted = false,
    layoutType = 'default',
    isClientParametersVisible = true,
}) => {
    const { type: reserveType, bonus } = reserveInfo

    const currentBonus = bonus.values[level - 1]
    const nextBonus = bonus.values[nextLevel - 1]

    const sortedBattleTypes = Object.keys(currentBonus.battle_types).sort(sortReserveBattleTypes)

    const reserveParameters = (() => {
        return sortedBattleTypes.map((battleType) => {
            const parameters = {}

            const currentValue = getReserveParameterByKey(currentBonus, battleType)
            const nextValue = getReserveParameterByKey(nextBonus, battleType)

            const bonusValue = isNextLevelHighlighted ? nextValue : currentValue
            parameters.bonus = {
                value: bonusValue.replace('%', ''),
                isHighlightEnabled: isNextLevelHighlighted && nextValue !== currentValue,
            }

            if (currentBonus.duration) {
                const durationValue = isNextLevelHighlighted ? nextBonus.duration : currentBonus.duration
                parameters.duration = {
                    value: durationValue / 3600,
                    isHighlightEnabled: isNextLevelHighlighted && nextBonus.duration !== currentBonus.duration,
                }
            }

            return parameters
        })
    })()

    return (
        <div className={cx(styles.base, styles[`base__${layoutType}Layout`])}>
            {isClientParametersVisible && currentBonus.parameters ? (
                <BonusParametersDescription
                    reserveType={reserveType}
                    layoutType={layoutType}
                    isNextLevelHighlighted={isNextLevelHighlighted}
                    currentBonus={currentBonus}
                    nextBonus={nextBonus}
                    battleTypes={sortedBattleTypes}
                />
            ) : (
                sortedBattleTypes.map((battleType, index) => {
                    return (
                        <SingleValueBonusDescription
                            key={battleType}
                            layoutType={layoutType}
                            battleType={battleType}
                            reserveType={reserveType}
                            bonusType={bonus.type}
                            reserveParameters={reserveParameters[index]}
                        />
                    )
                })
            )}
        </div>
    )
}

ReserveBonus.propTypes = {
    reserveInfo: PropTypes.object.isRequired,
    level: PropTypes.number.isRequired,
    nextLevel: PropTypes.number.isRequired,
    isNextLevelHighlighted: PropTypes.bool,
    isClientParametersVisible: PropTypes.bool,
    layoutType: PropTypes.oneOf(['default', 'tooltip', 'toolbar']),
}

export default ReserveBonus



// WEBPACK FOOTER //
// ./components/ReserveBonus/ReserveBonus.jsx